import get from 'lodash.get';
import { DEFAULT_LOCALE } from '../constants';

const getLocale = (rootState) => get(rootState, 'i18n.locale', DEFAULT_LOCALE);

export default getLocale;
